import moment from "moment";

const getFirstDateOfMonth = () => {
    const startOfMonth = moment().startOf('month').format('YYYY.MM.DD');
    return startOfMonth;
};
export default getFirstDateOfMonth;
